import router from "src/routes/routes";
import CommonAPIService from "./commonHandler";

const api = new CommonAPIService(router);

export const paymentTrackingService = {
  uploadPaymentCsv: async (file) => {
    const formData = new FormData();
    formData.append("csv", file);
    return api.postFormDataCall('/api/payment-tracking/upload-csv', formData);
  },

  getReconciliation: async (params) => {
    return api.getCall('/api/payment-tracking/reconciliation', params);
  },

  downloadReconciliation: async (params) => {
    return api.getBlobCall('/api/payment-tracking/reconciliation/csv', params);
  },

  adjustPayment: async (id, payload) => {
    return api.putCall(`/api/payment-tracking/${id}/adjust`, payload);
  },

  markPaid: async (id) => {
    return api.putCall(`/api/payment-tracking/${id}/mark-paid`);
  },

  getUploadHistory: async (params) => {
    return api.getCall('/api/payment-tracking/uploads', params);
  },

  createPayment: (payload) => api.postCall('/api/payment-tracking', payload),

  getPayment: (id) => api.getCall(`/api/payment-tracking/${id}`),

  updatePayment: (id, payload) => api.putCall(`/api/payment-tracking/${id}`, payload),

  deletePayment: (id) => api.deleteCall(`/api/payment-tracking/${id}`),
};
